var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavAmenities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .454h10.217V31H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.548.454h6.825V31H.548z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.592.454h10.535V31H.592z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.108 10.727c-1.51 0-2.79-.212-3.057-2.581h6.115c-.267 2.369-1.547 2.58-3.058 2.58M9.218.455a1 1 0 00-1 1v4.692h-2.11V1.454a1 1 0 00-2 0v4.692H2V1.454a1 1 0 00-2 0v5.692c0 3.367 1.354 5.17 4.108 5.51V30a1 1 0 102 0V12.656c2.755-.34 4.11-2.143 4.11-5.51V1.454a1 1 0 00-1-1",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 .546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.551 15.316c-.028-3.37.357-10.04 2.463-12.23.118-.121.237-.226.36-.312v12.542H2.55zM6.373.454c-1.063 0-2.006.42-2.8 1.248C.232 5.176.528 15.222.573 16.356a1 1 0 001 .96h3.8V30a1 1 0 002 0V1.454a1 1 0 00-1-1z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 .546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.86 11.367c-1.802 0-3.268-2-3.268-4.457 0-2.458 1.466-4.457 3.267-4.457 1.802 0 3.268 2 3.268 4.457s-1.466 4.457-3.268 4.457m5.268-4.457c0-3.56-2.363-6.457-5.268-6.457C2.955.453.592 3.35.592 6.91c0 3.141 1.84 5.762 4.267 6.337V30a1 1 0 002 0V13.247c2.428-.575 4.268-3.196 4.268-6.337",
    mask: "url(#f)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAmenities);
export default __webpack_public_path__ + "static/media/nav-amenities.be581552ae88004e20ef87cce5fa921e.svg";
export { ForwardRef as ReactComponent };